import React, { Component } from 'react'
import Layout from './../../wrapper'
import { connect } from 'react-redux'
import withTranslationWrapper from '../../HOC/HocTranslate'
import { notifyError, notifySuccess } from '../../Utils/CustomNotifcations'
import { ResourceList } from '../../Components/Billing/index'
import { logInUserInfo } from '../../Actions/Users'
import { checkPrivileges } from '../../Helpers'
import axios from 'axios'
import withRoutes from '../../HOC/HocRoutes'
import instance from '../../axios'
import { apiFetch } from '../../Utils/apiFetch'


let source;



class Billings extends Component {
  constructor(props) {
    super(props);
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // Adding 1 as months are zero-based
    const currentYear = currentDate.getFullYear();
  
    this.state = {
      isVisable: true,
      sessionCallTrack: true,
      selectedDate: "",
      month: currentMonth,
      year: currentYear,
      selectedAccount: '',
      loader: false,
      defaultAccountsList: [],
      itemSelected:false,
      pageSize:20,
      page:1,
      search:"",
      childData:  {},
      selectedInvoice:''

    };
  }
  componentDidMount () {
        // this.props.dispatch(Notifications.removeAll())
    if(this.props.logInUser ){
      this.fetchUsersList()
      this.getInvoices(this.props.logInUser.id)
    }
  }
  controleSession = () => {
    if (localStorage.getItem('userInfo')) {
      apiFetch('/api/session', {
        method: 'DELETE'
      }).then(res => {
        let response = res.data
        if (response.ok) {
          this.props.navigate('/logout')
        }else{
          throw response
        }
      }).catch(e => {})
    }
  }
  fetchUsersList = id => {
    apiFetch(`/api/users/list?userId=${this.props.logInUser.id}&limit=100&all=true`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        response.json().then(res => {
          if(res.status === 'success'){
            let data =res.data
            let result = data.data.map(item => ({
              ...item,
              label: item.label || item.name,
              value: item.id
            }))
            if (result.length === 0) {
              this.setState({
                resultMessage: 'No option found',
                defaultOption: ''
              })
            } else {
              this.setState({
                resultMessage: '',
                defaultAccountsList: result
              })
            }
          }
          else if(res?.statusCode === '440'){
            window.location.replace('/login')
          }
           else if(res.statusCode){
            var err = res?.message.split(':')
            err[1] =err[1].replace(')', "")
            this.props.dispatch(
              notifyError(err[1])
            )
          }
         
        })
      }
      else{
        throw response
      }
    }).catch(e => {})
  }

  searchList = async inputValue => {
    if (!inputValue) {
      return []
    }

    let response = await apiFetch(
      `/api/users/list?userId=${this.props.logInUser.id}&all=true&search=${inputValue}&limit=100`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
    let json = await response.json()
    let result =
      (await json.data) && (json.data.data) &&
      json.data.data.map(item => ({
        ...item,
        label: item.label || item.name,
        value: item.id
      }))
    if (result.length === 0) {
      this.setState({
        resultMessage: 'No option found'
      })
    } else {
      this.setState({
        resultMessage: ''
      })
    }

    if (json.hasNext) {
      result.push({
        value: null,
        isDisabled: true,
        label: 'Search for more.'
      })
    }
    return result
  }
  handleChangeAccount = (name, value) => {
    this.setState(
      {
          [name]: value.value,
          accountLabel:value.label
      },()=>this.checkRequiredFields())
  }

checkRequiredFields = () => {
  const { selectedAccount, selectedDate } = this.state;
  this.setState({
    isVisible: !!(selectedAccount && selectedDate)
  });
};

  handleChange = name => date => {
    if (date) {
      // Check if date is a moment object, then convert it to a native Date object
      if (typeof date.getMonth !== 'function') {
        date = date.toDate();
      }
  
      if (!isNaN(date.getTime())) {
        const selectedMonth = date.getMonth() + 1; // Months are 0-indexed, so add 1
        const selectedYear = date.getFullYear();
  
        this.setState({
          selectedDate: date.toISOString(),
          month: selectedMonth,
          year: selectedYear,
        },()=>this.checkRequiredFields());
      } else {
        console.error("Invalid date provided");
      }
    } else {
      // Handle case where date is null (e.g., when cleared)
      this.setState({
        selectedDate: null,
        month: null,
        year: null,
      },()=>this.checkRequiredFields());
    }
  };
  
  

  
  getInvoices = (userId) => {
    // this.state.selectedAccount
    let { month, year, page, pageSize, search } = this.state;
    let id = this.state.selectedAccount ? this.state.selectedAccount: this.props.logInUser.id;
    source = axios.CancelToken.source();
    this.setState({ loader: true }, () => {
      instance.get(`/api/invoices?userId=${id}&month=${month}&year=${year}&page=${page}&limit=${pageSize}&search=${search}`, {
        cancelToken: source.token,
      })
      .then(response => {
        if (response.status === 200) {
          let res = response.data;
          if (res.status === 'success') {
            this.setState({
              tableData: res.data || [],
              loader: false,
            });
          } else if (res?.statusCode === '440') {
            window.location.replace('/login');
          } else if (res.statusCode) {
            var err = res?.message.split(':');
            err[1] = err[1].replace(')', '');
            this.props.dispatch({
              type: 'error',
              payload: {
                message: this.props.translate(err[1]),
                autoDismiss: 5,
                location: this.props.location,
              },
            });
          }
        }
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
        } else {
          this.props.dispatch({
            type: 'error',
            payload: {
              message: 'Something went wrong',
              autoDismiss: 5,
              location: this.props.location,
            },
          });
        }
      });
    });
  };

downloadInvoices = () => {
  const { month, year, selectedAccount } = this.state;
  const userId = selectedAccount || this.props.logInUser.id;

  const url = `/api/invoices/export?userId=${userId}&month=${month}&year=${year}`;

  this.setState({ loader: true }, () => {
    apiFetch(url, {
      method: "GET",
      headers: {
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          return response.blob();
        } else {
          throw new Error(`Failed to download: ${response.statusText}`);
        }
      })
      .then((blob) => {
        this.setState({ loader: false }, () => {
          this.saveData(blob, `Invoices.xlsx`);
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        console.error("Download error:", error);
      });
  });
};


saveData = (blob, filename) => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.style.display = "none";

    document.body.appendChild(a);
    a.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
};


  getItems = (item) => {
    let { page, pageSize, search } = this.state;
    source = axios.CancelToken.source();

    this.setState({ loader: true }, () => {
      instance.get(`/api/invoices/${item.id}/items?page=${page}&limit=${pageSize}&search=${search}`, {
        cancelToken: source.token,
      })
      .then(response => {
        if (response.status === 200) {
          let res = response.data;
          if (res.status === 'success') {
            this.setState({
              itemSelected: true,
              selectedInvoice: item,
              childData: res.data || [],
              loader: false,
              search: '',
            });
          } else if (res?.statusCode === '440') {
            window.location.replace('/login');
          } else if (res.statusCode) {
            var err = res?.message.split(':');
            err[1] = err[1].replace(')', '');
            this.props.dispatch({
              type: 'error',
              payload: {
                message: this.props.translate(err[1]),
                autoDismiss: 5,
                location: this.props.location,
              },
            });
          }
        }
      })
      .catch(error => {
        this.props.dispatch({
          type: 'error',
          payload: {
            message: 'Something went wrong',
            autoDismiss: 5,
            location: this.props.location,
          },
        });
      });
    });
  };

  // invoiceSelection = item =>{
  //   this.setState(
  //     {
  //       itemSelected:true,
  //       // childData: item.items || []
  //     },()=>this.getItems(item.id)
  //     )
  // }
  goBack = () =>{
    this.setState(
      {
        itemSelected:false,
        childData:  [],
        selectedInvoice:{},
        page:1,
        pageSize:20,
        search:""
      },
        () => {
        })
  }


  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = () => {
    let nAcc ;
    if(this.state.itemSelected){
      nAcc = { ...this.state.childData };
    }else{
      nAcc = { ...this.state.tableData };
    }

    let lastPage = nAcc.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nAcc.data;
    nAcc.pageSize = this.state.pageSize;
    nAcc.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nAcc;
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({page:1, pageSize: rowsPerPage }, () => {
      if(this.state.itemSelected){
        this.getItems(this.state.selectedInvoice);
      }else{
        this.getInvoices();
      }
    });
  };

  handleChangePage = (value) => {
    this.setState({ page: value }, () => {
      if(this.state.itemSelected){
        this.getItems(this.state.selectedInvoice);
      }else{
      this.getInvoices();
      }
    });
  };

  searchItem= (e) => {
    source.cancel();
    this.setState(
      {
        page:1,
        search: e,
      },
      () => {
        if(this.state.itemSelected){
          this.getItems(this.state.selectedInvoice);
        }else{
        this.getInvoices();
        }
      }
    );
  };
  render () {
    if (this.props.logInUser.userType === -1) {
      if (this.props.logInUser) {
        if (this.props.logInUser.userType === 6) {
          this.props.navigate('/*')
        } else {
          return (
            <Layout
            {...this.props}
            {...this.state}
          
            noSidebar={this.state.itemSelected ? true : false}
            searchList={this.searchList}
            submitForm={this.getInvoices}
            downloadInvoices={this.downloadInvoices}
            handleChangeAccount={this.handleChangeAccount}
            handleChange={this.handleChange}
            addItem={this.addItem}
            selecteItem={this.selecteItem}
            removedItem={this.removedItem}
            editItem={this.editItem}
          >
              <ResourceList
               {...this.props} 
                {...this.state}
                childData={this.state.childData}
                searchItem={this.searchItem}
                setPagination={this.setPagination}
                handleChangePage={this.handleChangePage}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                invoiceSelection={this.getItems}
                goBack={this.goBack}
                />
            </Layout>
          )
        }
      } else {
        if (this.state.sessionCallTrack) {
          this.setState(
            {
              sessionCallTrack: false
            },
            () => {
              apiFetch('/api/session?app=2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312', {
                headers: { Accept: 'application/json; odata=verbose' }
              }).then(response => {
                if (response.ok) {
                  response.json().then(res => {
                    if(res.status ==='success'){ 
                      let userInfo = res.data
                      this.props.setActiveLanguage(
                        userInfo?.attributes?.lang || 'en'
                      )
  
                      //API privilige call
                      apiFetch(`/api/roles/privileges?roleId=${userInfo.roleId}`, {
                        method: 'Get'
                      }).then(response => {
                          if (response.ok) {
                            response.json().then(res2 => {
                              if(res.status ==='success'){ 
                                let privileges = res2.data
                                let privilegeKeys = []
                                privileges.map(item => {
                                  privilegeKeys.push(item.privilegeKey)
                                })
                                localStorage.setItem(
                                  'privileges',
                                  JSON.stringify({ ...privilegeKeys })
                                )
                                if (privileges.length) {
                                  localStorage.setItem('userToken', '')
                                  this.props.navigate('/billings')
                                } else {
                                  this.setState({
                                    loading: false,
                                    loginErrorMessage: 'lackOfPrivileges'
                                  })
                                }
                              }
                              else if(res?.statusCode === '440'){
                                window.location.replace('/login')
                              }
                              else if(res.statusCode){
                                var err = res?.message.split(':')
                                err[1] =err[1].replace(')', "")
                                this.props.dispatch(
                                  notifyError(this.props.translate(err[1]))
                                )
                              }
                            })
                          } else {
                            throw response
                          }
                        }).catch(e => {
                            console.log('e =',e)
                          // this.props.dispatch(notifyError({
                          //   message: 'somethingWentWrong',
                          //   autoDismiss: 5
                          // }))
                        })
  
                      //Privilige call ends
  
                      this.props.dispatch(logInUserInfo(userInfo))

                    }
                    else if(res?.statusCode === '440'){
                      window.location.replace('/login')
                    }
                    else if(res.statusCode){
                      var err = res?.message.split(':')
                      err[1] =err[1].replace(')', "")
                      this.props.dispatch(
                        notifyError(err[1])
                      )
                      this.props.navigate('/logout')
                    }
                  })
                } else {
                  this.props.navigate('/logout')
                    throw response
                  }
                }).catch(e => {
                  this.props.dispatch(notifyError('somethingWentWrong'))
                })
            }
          )
        }
        return null
      }
    } else if (
      !checkPrivileges('account') &&
      !checkPrivileges('user') &&
      !checkPrivileges('device')
    ) {
      this.controleSession()
      return null
    } else {
      return defaultPages.map(page => {
        if (checkPrivileges(page)) {
          if (page === 'device') {
            this.props.navigate(`/units`)
          } else {
            this.props.navigate(`/${page}s`)
          }
        }
      })
    }
  }
}
const mapStateToProps = state => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  users: state.users
})

export default connect(mapStateToProps)(withRoutes(withTranslationWrapper(Billings)))

const defaultPages = ['account', 'user', 'device']
